import { 
  useMultiPotAmounts,
  useWinningPotDisplay,
  useGameId,
  useIsWinnerDeclared,
  useTotalPotAmount,
  useGameDefinition
} from '@/src/hooks/data/useGameTable';
import React, { useEffect, useState, useCallback } from 'react'
import styles from './PotAmounts.module.css';
import PotAmount from './PotAmount';

export default function PotAmountContainer({ tempTableId }) {
  const multiPotAmounts = useMultiPotAmounts(tempTableId);
  const winningPotDisplay = useWinningPotDisplay(tempTableId);
  const gameId = useGameId(tempTableId);
  const isWinnerDeclared = useIsWinnerDeclared(tempTableId);
  const totalPotAmt = useTotalPotAmount(tempTableId);
  const gameDefinition = useGameDefinition(tempTableId);
  const bigBlind = gameDefinition?.bigBlind;


  // const chipArray = Array.from({ length: 10 });
  const [hiddenPots, setHiddenPots] = useState([]);

  const updateHiddenPots = useCallback(
    (shouldHidePot, index) => {
      if (shouldHidePot) {
        let alreadyHiddenPots = [];
        for (let i = 0; i < index; i++) {
          if (i < index) {
            alreadyHiddenPots.push(i);
          }
        }
        let timeout;
        timeout = setTimeout(() => {
          setHiddenPots([index, ...hiddenPots, ...alreadyHiddenPots]);
          clearTimeout(timeout);
        }, 1000);
      }
    },
    [hiddenPots]
  );

  useEffect(() => {
    setHiddenPots([]);
  }, [gameId, multiPotAmounts]);

  useEffect(() => {
    if (winningPotDisplay) {
      updateHiddenPots(true, winningPotDisplay?.potIndex);
    }
  }, [winningPotDisplay, updateHiddenPots]);


  const run1Pots = multiPotAmounts?.filter((pot) => pot.run === 1) || [];
  const run2Pots = multiPotAmounts?.filter((pot) => pot.run === 2) || [];

  return (
    <div className={styles.potAmountContainer}>
      <div className={styles.multiPotContainer}>
        {run1Pots?.map((pot, index) => (
          <PotAmount bigBlind={bigBlind} totalPotAmt={totalPotAmt} isWinnerDeclared={isWinnerDeclared} potsLength={run1Pots.length} hiddenPots={hiddenPots} index={index} run={1} winningPotData={winningPotDisplay} key={'potAmountContainer-run1-index-' + index} pot={pot} />
        ))}
      </div>
      <div className={styles.multiPotContainer}>
        {run2Pots?.map((pot, index) => (
          <PotAmount bigBlind={bigBlind} totalPotAmt={totalPotAmt} isWinnerDeclared={isWinnerDeclared} potsLength={run1Pots.length} hiddenPots={hiddenPots} index={index} run={2} winningPotData={winningPotDisplay} key={'potAmountContainer-run2-index-' + index} pot={pot} />
        ))}
      </div>
    </div>
  )
}
